import { useApiClientStore } from '~/@utils/api/apiClientStore'

export const getApi = () => {
  const apiClient = useApiClientStore.getState().apiClient

  return apiClient.apiInstance.app
}
